import d from "../../node_modules/.pnpm/react-slider@2.0.4_react@17.0.2/node_modules/react-slider/dist/es/dev/index.mjs";export default d;